/* GASSISA
=========================================================================================
* Descripcion: Venta Super autonoma para dispositivos portatiles.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revision   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Creacion de version portatil responsiva
*      2       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Ajuste de distribucion visual portatil
 *      3       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Implementacion autonoma con modales portatiles
 *      4       | 30/08/2026 | Lic. Jose Luis Aragon Cervantes  | Alt+F12 elimina venta con confirmacion; reimpresion pasa a Alt+P
 * ---------------------------------------------------------------------------------------
*/

import { Fragment, useEffect, useRef, useState } from "react";
import { Chip, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";

import { useSesion } from "../../../context/System/SesionContext";
import { useVentas } from "../../../context/Ventas/VentasContext";
import { useRequest } from "../../../context/System/RequestContext";
import { useLayout } from "../../../context/System/LayoutContext";
import { apiStatusCaja } from "../../../settings/ApiConfig";
import { useListenVentasReset } from "../../../hooks/useBrowserTabsSync";
import { useFormTabLock } from "../../../hooks/useFormTabLock";

import SizeSoftXFrmPortatil from "../leyout/SizeSoftXFrmPortatil.jsx";
import SizeSoftXLectorCodigoBarrasPortatil from "../leyout/SizeSoftXLectorCodigoBarrasPortatil.jsx";
import SizeSoftXTableVentas from "../../leyout/SizeSoftXTableVentas";
import SizeSoftXDetallesVentas from "../../leyout/SizeSoftXDetallesVentas";
import SizeSoftXVentasLayout from "../../leyout/SizeSoftXVentasLayout";
import SizeSoftXAlert from "../../utils/SizeSoftXAlert";
import SizeSoftXLoadingProcess from "../../leyout/SizeSoftXLoadingProcess";

import MnuVentasActionsPortatil from "./MnuVentasActionsPortatil.jsx";
import MnuOtherActionsPortatil from "./MnuOtherActionsPortatil.jsx";
import ModalBuscarArticulosParaVentaPortatil from "../modales/ModalBuscarArticulosParaVentaPortatil.jsx";
import ModalEditarPartidasVentasPortatil from "../modales/ModalEditarPartidasVentasPortatil.jsx";
import ModalCobroVentasPortatil from "../modales/ModalCobroVentasPortatil.jsx";
import ModalJalarPreventasCotizacionesPortatil from "../modales/ModalJalarPreventasCotizacionesPortatil.jsx";
import ModalGenerarApartadosPortatil from "../modales/ModalGenerarApartadosPortatil.jsx";
import ModalAplicacionDescuentosPortatil from "../modales/ModalAplicacionDescuentosPortatil.jsx";
import ModalValidarClientePortatil from "../modales/ModalValidarClientePortatil.jsx";
import FrmLoginValidatePortatil from "../modales/FrmLoginValidatePortatil.jsx";
import ModalAperturaCajaPortatil from "../modales/ModalAperturaCajaPortatil.jsx";
import ModalCierreCajaPortatil from "../modales/ModalCierreCajaPortatil.jsx";
import ModalRetiroCapitalPortatil from "../modales/ModalRetiroCapitalPortatil.jsx";
import ModalReimpresionRemisionesPortatil from "../modales/ModalReimpresionRemisionesPortatil.jsx";
import SizeSoftXConfirmDialog from "../../leyout/SizeSoftXConfirmDialog";
import ModalBuscarClientesPortatil from "../modales/ModalBuscarClientesPortatil.jsx";

export default function FrmVentaSuperPortatil() {
  const navigate = useNavigate();
  const lectorRef = useRef(null);
  const ventaLeftRef = useRef(null);
  const listaAnteriorRef = useRef([]);
  const { isLocked, lockInfo } = useFormTabLock("ventas", { title: "Ventas" });
  const { usuarioData, parametrosCajaForm, handleObtenerParametrosCaja } = useSesion();
  const { handleOpenAlert } = useLayout();
  const { GetRequest } = useRequest();

  const [clienteParaDescuento, setClienteParaDescuento] = useState(null);
  const [statusCajaActual, setStatusCajaActual] = useState(null);
  const [mostrarBuscadorArticulos, setMostrarBuscadorArticulos] = useState(false);
  const [modoCarga, setModoCarga] = useState("PREVENTA");
  const [openModalAperturaCaja, setOpenModalAperturaCaja] = useState(false);
  const [openModalCierreCaja, setOpenModalCierreCaja] = useState(false);
  const [openModalReimpresion, setOpenModalReimpresion] = useState(false);
  const [openConfirmEliminarVenta, setOpenConfirmEliminarVenta] = useState(false);
  const [openLoginApertura, setOpenLoginApertura] = useState(false);
  const [openLoginCierre, setOpenLoginCierre] = useState(false);

  const {
    listaRemisionTemporal,
    partidaSeleccionada,
    handleChangePartidaSeleccionada,
    handleClickEditarPartida,
    handleCerrarModalEditarPartidas,
    handleClickRefrescarDatosVenta,
    handleRetotalizarCuentaVenta,
    handleClickEliminarPartidaVentas,
    handleSumarPartidaVentas,
    handleRestarPartidaVentas,
    handleBuscarClienteFromClave,
    handleCerrarModalCobrarVenta,
    openModalPartidas,
    clienteForm,
    openModalCobrarVenta,
    handClickCobrarVenta,
    setVentaTotales,
    ventaTotales,
    handleCloseModalBuscarArticulos,
    statusCloseModal,
    handleRegistrarArticuloSubmitVenta,
    handleCambioTipoVenta,
    handleCerrarModalJalarPreVentaCotizacion,
    handleInyectarPreventaCotizacionAVenta,
    openModalJalarPreventaCotizacion,
    handleCerrarModalGenerarApartado,
    handleGenerarApartadoSubmit,
    openModalGenerarApartado,
    statusAbrirDescuentos,
    handeCerrarModalDescuentos,
    statusWaiting,
    openModalValidarAcceso,
    handleCloseModalLoginValidarAcceso,
    handleAbrirDescuentosVenta,
    handleClickDescuentoVenta,
    statusValidarCliente,
    handleCerrarValidarCliente,
    handleViewFormDescuentos,
    handleClickRegresarMainDashboard,
    handleAbrirModalJalarPreVentaCotizacion,
    setStatusKeyActions,
    handleArirModalBuscarArticulos,
    handleArirModalBuscarCliente,
    handleCerrarModalBuscarCliente,
    openModalBuscarCliente,
    handleArirModalCobrarVenta,
    handleAbrirModalGenerarApartado,
    handleClickEliminarVenta,
    setModuloActivo,
    openModalRetiroCapital,
    openModalLoginRetiro,
    setOpenModalLoginRetiro,
    handleCerrarRetiroCapital,
    handleRetiroCapitalExitoso,
    handleConfirmLoginRetiro,
    usuarioAutorizadoRetiro,
    setClienteForm,
    handleInicializarVentanaVentas,
  } = useVentas();

  const verificarStatusCaja = async () => {
    if (!parametrosCajaForm.caja || parametrosCajaForm.caja === "CAJA-DEFAULT") {
      handleOpenAlert("Caja no configurada", "warning");
      return { puedeCobrar: false, statusCaja: null };
    }
    try {
      const response = await GetRequest({ url: apiStatusCaja.replace("{caja}", parametrosCajaForm.caja) });
      if (response.hasError) {
        handleOpenAlert(response.message, "error");
        return { puedeCobrar: false, statusCaja: null };
      }
      setStatusCajaActual(response.result);
      return { puedeCobrar: Boolean(response.result?.abierta), statusCaja: response.result, necesitaApertura: !response.result?.abierta };
    } catch (error) {
      handleOpenAlert(`Error al verificar caja: ${error.message}`, "error");
      return { puedeCobrar: false, statusCaja: null };
    }
  };

  const verificarYAbrirCobro = async () => {
    if (!listaRemisionTemporal.length) return handleOpenAlert("No hay articulos en la venta para cobrar");
    const resultado = await verificarStatusCaja();
    if (resultado.necesitaApertura) {
      handleOpenAlert(`La caja ${resultado.statusCaja?.caja || ""} está cerrada`, "warning");
      setOpenModalAperturaCaja(true);
    } else if (resultado.puedeCobrar) handleArirModalCobrarVenta();
  };

  const abrirBuscadorArticulos = () => {
    if (!statusCajaActual?.abierta) return handleOpenAlert("No se pueden realizar operaciones con la caja cerrada", "warning");
    setMostrarBuscadorArticulos(true);
    handleArirModalBuscarArticulos();
    setTimeout(() => {
      const input = document.querySelector('.modal-buscador-articulos-portatil input[name="Filtro"]');
      input?.focus?.({ preventScroll: true });
      input?.select?.();
    }, 120);
  };

  const registrarArticuloDesdeModal = async (articulo, almacen) => {
    setMostrarBuscadorArticulos(false);
    await handleCambioTipoVenta("VENTA");
    await handleRegistrarArticuloSubmitVenta(articulo.codigobarras, almacen);
    handleCloseModalBuscarArticulos();
    setTimeout(() => lectorRef.current?.focusAndSelect?.(), 120);
  };

  const handleClienteLocalizado = async (cliente) => {
    setClienteParaDescuento(cliente);
    setClienteForm(cliente);
    await handleViewFormDescuentos(true, cliente);
  };

  useEffect(() => {
    if (isLocked) {
      handleOpenAlert(`El formulario de ${lockInfo?.title || "Ventas"} ya está abierto en otra pestaña`, "error");
      setTimeout(handleClickRegresarMainDashboard, 900);
    }
  }, [isLocked]);

  useEffect(() => {
    handleCambioTipoVenta("VENTA");
    setModuloActivo("VENTA SUPER");
    setStatusKeyActions(false);
    handleObtenerParametrosCaja();
    handleCloseModalLoginValidarAcceso();
    handleClickRefrescarDatosVenta();
  }, []);

  useListenVentasReset(handleInicializarVentanaVentas);

  useEffect(() => {
    if (!parametrosCajaForm.caja || parametrosCajaForm.caja === "CAJA-DEFAULT") return;
    handleCloseModalLoginValidarAcceso();
    handleClickRefrescarDatosVenta();
  }, [parametrosCajaForm.folioventa]);

  useEffect(() => {
    if (parametrosCajaForm.caja && parametrosCajaForm.caja !== "CAJA-DEFAULT") verificarStatusCaja();
  }, [parametrosCajaForm.caja]);

  useEffect(() => {
    handleRetotalizarCuentaVenta(listaRemisionTemporal);
    if (listaAnteriorRef.current.length && listaRemisionTemporal.length > listaAnteriorRef.current.length) {
      ventaLeftRef.current?.scrollTo?.({ top: ventaLeftRef.current.scrollHeight, behavior: "smooth" });
    }
    listaAnteriorRef.current = listaRemisionTemporal;
  }, [listaRemisionTemporal]);

  useEffect(() => {
    if (statusCloseModal) handleClickRefrescarDatosVenta();
  }, [statusCloseModal]);

  useEffect(() => {
    const onKeyDown = (event) => {
      const key = event.key?.trim().toUpperCase();
      if (event.altKey && key === "F3") handleClickDescuentoVenta();
      else if (event.altKey && key === "O") { setModoCarga("COTIZACION"); handleAbrirModalJalarPreVentaCotizacion("COTIZACION"); }
      else if (event.altKey && key === "J") { setModoCarga("PREVENTA"); handleAbrirModalJalarPreVentaCotizacion("PREVENTA"); }
      else if (key === "F4") handleClickRegresarMainDashboard();
      else if (event.altKey && key === "F10") verificarYAbrirCobro();
      else if (event.altKey && key === "F7") handleClickEliminarPartidaVentas(partidaSeleccionada?.idpartida);
      else if (event.altKey && key === "F12") setOpenConfirmEliminarVenta(true);
      else if (event.ctrlKey && event.altKey && key === "A") handleAbrirModalGenerarApartado();
      else if (event.altKey && key === "P") setOpenModalReimpresion(true);
      else if (event.altKey && key === "F2") handleArirModalBuscarCliente();
      else if (event.altKey && key === "F1") abrirBuscadorArticulos();
      else if (event.altKey && key === "V") navigate("/devoluciones", { replace: true });
      else return;
      event.preventDefault();
      event.stopPropagation();
    };
    window.addEventListener("keydown", onKeyDown, true);
    return () => window.removeEventListener("keydown", onKeyDown, true);
  }, [statusCajaActual, listaRemisionTemporal.length, partidaSeleccionada?.idpartida]);

  const abrirApertura = () => parametrosCajaForm.caja && parametrosCajaForm.caja !== "CAJA-DEFAULT" ? setOpenLoginApertura(true) : handleOpenAlert("No hay caja seleccionada", "warning");
  const abrirCierre = () => parametrosCajaForm.caja && parametrosCajaForm.caja !== "CAJA-DEFAULT" ? setOpenLoginCierre(true) : handleOpenAlert("No hay caja seleccionada", "warning");

  return (
    <SizeSoftXFrmPortatil nombreFormulario="FrmVentaSuper">
      <Fragment>
        <SizeSoftXVentasLayout
          titlePage="Modulo de venta super"
          buttonActions={<MnuVentasActionsPortatil disabled={!statusCajaActual?.abierta} onOpenBuscador={abrirBuscadorArticulos} onOpenReimpresion={() => setOpenModalReimpresion(true)} onCobrar={verificarYAbrirCobro} onJalarPreventas={() => { setModoCarga("PREVENTA"); handleAbrirModalJalarPreVentaCotizacion("PREVENTA"); }} />}
          detailComponent={null}
        >
          <div className="title-page venta-header-card venta-super-portatil__header">
            <div><small>CAJA</small><strong>{parametrosCajaForm.caja}</strong>{statusCajaActual && <Chip label={statusCajaActual.status} color={statusCajaActual.abierta ? "success" : "error"} size="small" />}</div>
            <div><small>TICKET</small><strong>{parametrosCajaForm.folioventa}</strong></div>
            <div><small>ATIENDE</small><strong>{usuarioData.Usuario}</strong><span>{usuarioData.Nombre}</span></div>
            <div><small>CLIENTE</small><strong>{clienteForm.clavecliente ? `${clienteForm.clavecliente} - ` : ""}{clienteForm.razonsocial || "Sin cliente"}</strong></div>
            <div><small>DESCUENTO</small><strong>{clienteForm.porcentajedescuento || 0}%</strong></div>
            <div><small>CONTACTO</small><strong>{clienteForm.contacto || "-"}</strong></div>
          </div>

          <div className="venta-super-container">
            <div className="venta-super-left" ref={ventaLeftRef}>
              <SizeSoftXTableVentas
                columns={[
                  { field: "editrow", render: () => <IconButton onClick={handleClickEditarPartida}><EditIcon color="primary" /></IconButton>, width: 30 },
                  { title: "Origen", field: "almacenexhibidor", width: 120 },
                  { title: "Preventa", field: "nombrevendedor", width: 100 },
                  { title: "Partida", field: "idpartida" },
                  { title: "Descripcion", field: "descripcion" },
                  { title: "Medida", field: "medida" },
                  { title: "Cantidad", field: "cantidad" },
                  { title: "Costo cliente", field: "costocliente" },
                  { title: "%", field: "porcentajedescuento" },
                  { title: "Descuento", field: "descuento" },
                  { title: "Subtotal", field: "subtotal" },
                  { title: "IVA", field: "iva" },
                  { title: "Total", field: "total" },
                  { title: "Costo unitario", field: "costounitario" },
                  { title: "Clave articulo", field: "clavearticulo" },
                  { title: "Folio preventa", field: "foliopreventa" },
                ]}
                data={listaRemisionTemporal ?? []}
                id="idpartida"
                row={partidaSeleccionada}
                setRow={handleChangePartidaSeleccionada}
                fnDoubleClick={handleClickEditarPartida}
                fontSize="small"
                rowsPerPageIntro={50}
              />
            </div>
            <div className="venta-frame-right">
              <div className="venta-super-right-wrapper"><div className="venta-super-lector-especifico"><SizeSoftXLectorCodigoBarrasPortatil ref={lectorRef} TipoVenta="VENTA" disabled={!statusCajaActual?.abierta} /></div></div>
              <div className="venta-super-right-wrapper"><div className="venta-super-detalles-especifico"><SizeSoftXDetallesVentas ventasTotales={ventaTotales} /></div></div>
            </div>
          </div>

          <ModalBuscarArticulosParaVentaPortatil openModal={mostrarBuscadorArticulos} handleCloseModal={() => { setMostrarBuscadorArticulos(false); handleCloseModalBuscarArticulos(); }} dominio={parametrosCajaForm.dominio} consultarTodosAlmacenes skipFullData={true} onTallaSelect={() => {}} articuloSelect={registrarArticuloDesdeModal} />
          <ModalEditarPartidasVentasPortatil openModal={openModalPartidas} rowSelect={partidaSeleccionada} handleClose={handleCerrarModalEditarPartidas} handleEliminar={() => { handleClickEliminarPartidaVentas(partidaSeleccionada?.idpartida); handleCerrarModalEditarPartidas(); }} handleSubmitEditarPartidaVentaSumar={handleSumarPartidaVentas} handleSubmitEditarPartidaVentaRestar={handleRestarPartidaVentas} />
          <ModalCobroVentasPortatil openModalCobrarVentas={openModalCobrarVenta} montosVenta={ventaTotales} setMontosVenta={setVentaTotales} handleCloseModalCobroVentas={handleCerrarModalCobrarVenta} handleCobrar={handClickCobrarVenta} />
          <ModalJalarPreventasCotizacionesPortatil openModalJalarPreventaCotizacion={openModalJalarPreventaCotizacion} handleCloseModalJalarPreventaCotizacion={handleCerrarModalJalarPreVentaCotizacion} handleJalarPreventaCotizacion={handleInyectarPreventaCotizacionAVenta} modal={modoCarga} />
          <ModalGenerarApartadosPortatil openModalJalarPreventaCotizacion={openModalGenerarApartado} handleCloseModalGenerarApartados={handleCerrarModalGenerarApartado} handleGenerarApartado={handleGenerarApartadoSubmit} listaVentas={listaRemisionTemporal} />
          <ModalAplicacionDescuentosPortatil openModal={statusAbrirDescuentos} dataCliente={clienteParaDescuento} remisionVenta={parametrosCajaForm.folioventa} caja={(parametrosCajaForm.caja || "").trim()} handleCloseModalCambioCosto={handeCerrarModalDescuentos} data={listaRemisionTemporal ?? []} />
          <ModalValidarClientePortatil openModal={statusValidarCliente} handleClose={handleCerrarValidarCliente} handleClienteEncontrado={handleClienteLocalizado} />
          <FrmLoginValidatePortatil openModal={openModalValidarAcceso} tiposUsuario={["SA", "ADMINISTRADOR", "SUPERVISOR", "DESCUENTOS"]} handleComandoEjecucion={handleAbrirDescuentosVenta} hancleCloseModalValidator={handleCloseModalLoginValidarAcceso} />
          <ModalAperturaCajaPortatil openModal={openModalAperturaCaja} onClose={() => setOpenModalAperturaCaja(false)} onSuccess={() => { setOpenModalAperturaCaja(false); verificarStatusCaja().then(({ puedeCobrar }) => puedeCobrar && handleArirModalCobrarVenta()); }} caja={parametrosCajaForm.caja} />
          <ModalCierreCajaPortatil openModal={openModalCierreCaja} onClose={() => setOpenModalCierreCaja(false)} onSuccess={() => { setOpenModalCierreCaja(false); verificarStatusCaja(); }} caja={parametrosCajaForm.caja} statusCaja={statusCajaActual} usuario={usuarioData?.Usuario} />
          <ModalRetiroCapitalPortatil openModal={openModalRetiroCapital} onClose={handleCerrarRetiroCapital} onSuccess={handleRetiroCapitalExitoso} caja={parametrosCajaForm.caja} usuarioAutorizado={usuarioAutorizadoRetiro} />
          <ModalReimpresionRemisionesPortatil openModal={openModalReimpresion} onClose={() => setOpenModalReimpresion(false)} caja={parametrosCajaForm.caja} />
          <SizeSoftXConfirmDialog
            open={openConfirmEliminarVenta}
            title="Eliminar venta"
            message="¿Desea eliminar toda la venta actual?"
            handleConfirmDialog={(confirm) => {
              setOpenConfirmEliminarVenta(false);
              if (confirm) handleClickEliminarVenta();
            }}
          />
          <ModalBuscarClientesPortatil openModal={openModalBuscarCliente} handleCloseModal={handleCerrarModalBuscarCliente} onClienteSelect={async (cliente) => { setClienteParaDescuento(cliente); await handleBuscarClienteFromClave(cliente.clavecliente); handleCerrarModalBuscarCliente(); }} />
          <FrmLoginValidatePortatil openModal={openLoginApertura} tiposUsuario={["SA", "ADMINISTRADOR", "SUPERVISOR"]} handleComandoEjecucion={() => { setOpenLoginApertura(false); setOpenModalAperturaCaja(true); }} hancleCloseModalValidator={() => setOpenLoginApertura(false)} />
          <FrmLoginValidatePortatil openModal={openLoginCierre} tiposUsuario={["SA", "ADMINISTRADOR", "SUPERVISOR"]} handleComandoEjecucion={() => { setOpenLoginCierre(false); setOpenModalCierreCaja(true); }} hancleCloseModalValidator={() => setOpenLoginCierre(false)} />
          <FrmLoginValidatePortatil openModal={openModalLoginRetiro} tiposUsuario={["SA", "ADMINISTRADOR", "SUPERVISOR"]} handleComandoEjecucion={handleConfirmLoginRetiro} hancleCloseModalValidator={() => setOpenModalLoginRetiro(false)} />
          <SizeSoftXAlert />
          <MnuOtherActionsPortatil statusCajaActual={statusCajaActual} onAbrirAperturaCaja={abrirApertura} onAbrirCierreCaja={abrirCierre} />
          <SizeSoftXLoadingProcess open={statusWaiting} message="Procesando informacion, espere..." />
        </SizeSoftXVentasLayout>
      </Fragment>
    </SizeSoftXFrmPortatil>
  );
}
